import React, { useState, useEffect } from 'react';
import { useLocale } from './../components/special/LanguageProvider';
import { usePageLoadingContext } from './../components/messages/PageLoading';


export const AdminCatalog = (props) => {
  const { t } = useLocale();
  const setIsPageLoading = usePageLoadingContext();


   setIsPageLoading(false);

  return (
    <div>        
      <div className="grid tight collapse480">
          <div className="col s1of1">
              <h1 className="text-red text-32">Umsýsla</h1>              
          </div>
          <div className="col s1of1">
            <div>
                Stillingar og sérstakar aðgerðir í kerfinu.
                {/* <table className="table">
                <colgroup>
                    <col />
                    <col />
                    <col />
                    <col />
                </colgroup>
                <thead>
                </thead>
                <tbody>                
                    <tr>
                        <td className="text-center">
                            <h3>Stillingar</h3>
                            <span>Viðkvæmar kerfisstillingar sem hafa mikil áhrif á hegðun kerfisins.</span>
                        </td>
                        <td className="text-center">
                            <h3>Innheimtuþóknun</h3>
                            <span>Gjaldskrá......</span>
                        </td>
                        <td className="text-center">
                            <h3>Stillingar</h3>
                            <span>Viðkvæmar kerfisstillingar sem hafa mikil áhrif á hegðun kerfisins.</span>
                        </td>
                        <td className="text-center">
                            <h3>Stillingar</h3>
                            <span>Viðkvæmar kerfisstillingar sem hafa mikil áhrif á hegðun kerfisins.</span>
                        </td>
                    </tr>
                </tbody>
                </table>         */}
            </div>
          </div>
      </div>            
    </div>
  );
}

